import axios from 'axios'

import {AuthModel, SSOAuthModel} from '../models/AuthModel'
import {SSOUserModel} from '../models/UserModel'
import { IMenu } from '../models/MenuModel'
import { APIResponse } from '../../../models/HelperModel'

const API_URL = process.env.REACT_APP_API_URL

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/pegawai`
export const LOGIN_URL = `${API_URL}/authenticate`
export const REGISTER_URL = `${API_URL}/register`
export const REQUEST_PASSWORD_URL = `${API_URL}/forgot_password`
export const GET_MENU = `${API_URL}/menu/tree`

// Server should return AuthModel
export function login(username: string, password: string) {
  return axios.post<SSOAuthModel>(LOGIN_URL, {
    username,
    password,
  })
}

// Server should return AuthModel
export function register(email: string, firstname: string, lastname: string, password: string) {
  return axios.post<AuthModel>(REGISTER_URL, {
    email,
    firstname,
    lastname,
    password,
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  return axios.get<{result: boolean}>(REQUEST_PASSWORD_URL, {
    params: {
      email: email,
    },
  })
}

export function getUserByToken(accessToken: string) {
  // Authorization head should be fulfilled in interceptor.
  // Check common redux folder => setupAxios

  return axios.get<SSOUserModel>(GET_USER_BY_ACCESSTOKEN_URL, {
    headers: {Authorization: `Bearer ${accessToken}`},
  })
}

export function getMenu(accessToken: string) {
  return axios.get<IMenu[]>(GET_MENU, {
    headers: {Authorization: `Bearer ${accessToken}`}
  })
}
